import { Box, CircularProgress, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { remixerApi } from 'services/api/remixer';
import StudioSongItem from './StudioSongItem/StudioSongItem';
import { Container, LoadingContainer, StyledLoadingButton } from './styled';
import EmptyState from './components';

const StudioSongList = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [page, setPage] = useState(1);

  const { data, isLoading, isFetching, isError } =
    remixerApi.useGetStudioSongsQuery(page);

  if (isLoading) {
    return (
      <LoadingContainer>
        <CircularProgress size={theme.spacing(6.88)} />
      </LoadingContainer>
    );
  }

  if (isError) {
    return <Box>{t('library:studioSongs:getStudioSongsErrorMessage')}</Box>;
  }

  if (!data || Object.keys(data.songs).length === 0) {
    return <EmptyState />;
  }

  return (
    <Container>
      {data &&
        Object.values(data.songs).map((song) => (
          <StudioSongItem key={song.id} song={song} />
        ))}
      {!data.areAllPagesLoaded && (
        <StyledLoadingButton
          variant="outlined"
          loading={isFetching}
          onClick={() => setPage(page + 1)}
        >
          {t('general:action:loadMore')}
        </StyledLoadingButton>
      )}
    </Container>
  );
};

export default StudioSongList;
